import {
  SMART_APPLY_PARTNER_CONFIG,
  ADOBE_SUB_PRODUCT_LOGOS,
  type SmartApplyPartner
} from '@percent/cause-dashboard/constants/smartApplyPartnerConfig'

export const SMART_APPLY_PARTNER_LOGOS: Record<SmartApplyPartner, string> = Object.fromEntries(
  (Object.keys(SMART_APPLY_PARTNER_CONFIG) as SmartApplyPartner[]).map(key => [
    key,
    SMART_APPLY_PARTNER_CONFIG[key].logo
  ])
) as Record<SmartApplyPartner, string>

export { ADOBE_SUB_PRODUCT_LOGOS }
